import React from 'react';
import { TFunction } from 'i18next';
import { ExclamationTriangleIcon } from 'assets/icons';
import { theme } from 'styles';
import { Icon, WithTooltip } from 'UI';

export const EstimateMarginAlert = ({ t }: { t: TFunction }) => {
  return (
    <WithTooltip title={t('common.price.negative_or_zero_margin', 'Negative or zero Margin')} placement={'top'}>
      <Icon IconComponent={ExclamationTriangleIcon} size={20} display={'block'} color={theme.color.red} />
    </WithTooltip>
  );
};
